/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../Common/checkbox';
import useDropDownOpen from '../../hooks/useDropDownOpen';

const DefaultFilter = ({
  checkedOptions,
  all,
  unassigned,
  onFilterClick,
  filterName,
  options,
  title,
  filter
}) => {
  const [filterValue, setFilterValue] = useState('');

  const { open, setOpen } = useDropDownOpen();

  const filterOptions = (event) => {
    const input = event.target.value;
    setFilterValue(input);
  };

  const clearInput = () => {
    setFilterValue('');
  };

  const filteredOptions =
    filterValue.length > 0
      ? options.filter((option) =>
          option.name.toLowerCase().includes(filterValue)
        )
      : options;

  const handleButtonClick = () => {
    onFilterClick && onFilterClick(filterName, filteredOptions);
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <div className="dropdown">
      <button
        type="button"
        className="btn btn-link vrs-filter"
        onClick={handleButtonClick}
      >
        {title}
      </button>
      {open && (
        <ul className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <form>
            <li>
              {options.length > 5 && (
                <input
                  type="text"
                  name="filter"
                  value={filterValue}
                  onChange={filterOptions}
                />
              )}
              {filterValue.length > 0 && (
                <button
                  type="button"
                  className="btn btn-link red right"
                  title="Clear Input"
                  onClick={clearInput}
                >
                  X
                </button>
              )}
            </li>
            <li className="options">
              <>
                {unassigned && (
                  <CheckBox
                    label="Unassigned"
                    value="unassigned"
                    checked={checkedOptions.includes('unassigned')}
                    handleCheckboxChange={(value) =>
                      filter(value, filterName, options)
                    }
                  />
                )}
              </>
            </li>
            {filteredOptions.map((option) => (
              <li className="options" key={option.id}>
                <CheckBox
                  label={option.nickname || option.name}
                  value={option.id}
                  checked={checkedOptions.includes(option.id)}
                  handleCheckboxChange={(value) =>
                    filter(value, filterName, options)}
                />
              </li>
            ))}
            {all && (
              <li>
                <button
                  type="button"
                  className="btn btn-xs btn-primary"
                  onClick={() => filter('all', filterName, options)}
                >
                  All
                </button>
              </li>
            )}
          </form>
        </ul>
      )}
    </div>
  );
};

DefaultFilter.propTypes = {
  options: PropTypes.array,
  checkedOptions: PropTypes.array,
  all: PropTypes.bool,
  unassigned: PropTypes.bool,
  filter: PropTypes.func
};

DefaultFilter.defaultProps = {
  options: [],
  checkedOptions: [],
  all: true,
  unassigned: true
};

export default DefaultFilter;
